import { Component, inject, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { of, switchMap, map, tap } from 'rxjs';
import { TableColumn } from '../../models/TableColumn';
import { CustomerService } from '../../services/customer.service';
import { UserDTO } from 'src/app/models/UserDTO.model';

import { FormsModule } from '@angular/forms';
import { TableControlComponent } from '../../shared/controls/table-control/table-control.component';
@Component({
    selector: 'app-simSearch',
    templateUrl: './simSearch.component.html',
    styleUrls: ['./simSearch.component.scss'],
    imports: [FormsModule, TableControlComponent]
})
export class SimSearchComponent implements OnInit {

    private customerService = inject(CustomerService);
    private route = inject(ActivatedRoute);
    private router = inject(Router);
    public location = inject(Location);

    public sims: any[] = [];

    public textToSearch?: string | null;

    customerId?: number;
    searchValue: string | null = null;
    public columns: TableColumn[] = [
        /*
                { key: 'customerId', header: 'Customer Account' },    /customers/view-customer/1761/91
        */
        { key: 'customerName', header: 'Customer Name', width: 250, render: (value: any, row?: any) => `<a href="/customers/view-customer/${row.customerId}">${value}</a>`},
        { key: 'planName', header: 'Plan', render: (value: any, row?: any) => `<a href="/customers/view-customer/${row.customerId}/${row.userPlanId}">${value}</a>` },
        { key: 'carrier', header: 'Carrier' },
        { key: 'iccid', header: 'ICCID', render: (value: any, row?: any) => `<a href="/inventory/inventory-update/${value}">${value}</a>` },
        { key: 'imei', header: 'IMEI' },
        { key: 'userName', header: 'User Name' },
        { key: 'userName2', header: 'User Name 2' },
    ];

    public actionButtons = [
        { label: 'edit', class: 'primary', icon: 'bi bi-pencil-square' },
/*
        { label: 'archive', class: 'danger', icon: 'bi bi-archive' },
        { label: 'view', class: 'info', icon: 'bi bi-eye' },
*/
    ];


    ngOnInit() {
        this.customerId = +this.route.snapshot.paramMap.get('customerId')!;
        if (isNaN(this.customerId)) this.customerId = undefined;
        //this.textToSearch = this.route.snapshot.queryParamMap.get('s');
        this.textToSearch = history.state.searchText;
        if (this.textToSearch) this.searchSim();
    }


    public onAction(e: { action: string; item: any }): void {

        switch (e.action) {
            case 'edit':
                this.navigateToCustomerPlans(e.item.customerId);
                break;
/*
            case 'archive':
                //this.setArchivedPlan(event.item);
                //bootstrap.Modal.getOrCreateInstance(document.getElementById('modalArchive')).show();
                break;
            case 'view':
                //this.navigateToPlansView(event.item);
                break;
*/
        }
    }

    public searchSim() {
        //this.router.navigate([], { relativeTo: this.route, queryParams: { s: this.textToSearch }, queryParamsHandling: 'merge', replaceUrl: true });
        if (!this.textToSearch) return;
        history.replaceState({ searchText: this.textToSearch }, '');
        this.customerService.findCustomerPlans(this.textToSearch, this.customerId)
            .subscribe({
                next: response => {
                    this.sims = response;
                },
                error: e => console.error('Error when find customer plan by ICCID:', e)
            });
    }

    navigateToCustomerPlans(customer?: UserDTO | number) {
        customer && of(customer).pipe(
            switchMap(x =>
                typeof x === 'number'
                    ? this.customerService.getCustomerById({ userId: x }).pipe(map(x => x.Data))
                    : of(x)
            ),
            tap(c => {
                this.router.navigate(['/customers/customer-plans'], {
                    relativeTo: this.route,
                    state: { customerData: c },
                });
            })
        )
            .subscribe();
    }

}
